import styled from "styled-components";
import Container from "../../../Components/Container";
import Row from "../../../Components/Row";
import { Icon } from "@iconify/react";
import { Title } from "./styles";

const cards = [
  {
    icon: "mdi:brain",
    title: "IA do Alfred entende o momento da conversa",
    subtitle:
      "O Alfred identifica contatos inativos e entende quando existe espaço para retomar o atendimento.",
  },
  {
    icon: "mdi:chat-processing-outline",
    title: "Mensagens únicas para cada cliente",
    subtitle:
      "Cada follow-up é gerado com contexto, histórico e instruções da sua operação.",
  },
  {
    icon: "mdi:shield-check-outline",
    title: "Evite spam automaticamente",
    subtitle:
      "Se o cliente ainda estiver ativo ou não fizer sentido enviar mensagem, o Alfred simplesmente ignora.",
  },
  {
    icon: "mdi:calendar-month-outline",
    title: "Campanhas recorrentes no Whatsapp",
    subtitle:
      "Agende follow-ups diários, semanais ou campanhas de reativação em poucos cliques.",
  },
];

const CardsRow = styled(Row)`
  align-items: stretch;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 36px;
  border: 1px solid #ffffff20;
  border-radius: 20px;
  background: #0f0f0f;
  text-align: left;
  box-sizing: border-box;
`;

const IconBox = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 18px 22px;
  border-radius: 8px;
  background: #e4da1b10;
  margin-bottom: 28px;
`;

const CardTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  color: #ffffff;
  margin: 0 0 12px;
`;

const CardSubtitle = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 30px;
  color: #ffffff;
  margin: 0;
`;

const FollowUpContext = () => {
  return (
    <Container style={{ textAlign: "center", background: "#000000" }} full>
      <Row
        xs="1fr"
        sm="1fr"
        md="1fr"
        lg="1fr"
        xl="1fr"
        style={{ marginTop: "80px" }}
      >
        <Title style={{ fontWeight: 700, textAlign: "center", lineHeight: '51px' }}>
          Não é disparo em massa.
          <br />
          <span style={{ color: "#E4DA1B" }}>É contexto em escala.</span>
        </Title>
        <br />
        <br />
        <CardsRow
          xs="1fr"
          sm="1fr"
          md="1fr 1fr"
          lg="1fr 1fr 1fr 1fr"
          xl="1fr 1fr 1fr 1fr"
        >
          {cards.map((card) => (
            <Card key={card.title}>
              <IconBox>
                <Icon icon={card.icon} width={43} height={43} color="#e4da1b" />
              </IconBox>
              <CardTitle>{card.title}</CardTitle>
              <CardSubtitle>{card.subtitle}</CardSubtitle>
            </Card>
          ))}
        </CardsRow>
      </Row>
    </Container>
  );
};

export default FollowUpContext;
